export const flightRegion: any = {
  flightCountryList: "フライトの目的国一覧",
  flightRegionList: "{{country}}のフライトエリア一覧",
};
